export default __webpack_public_path__ + "static/media/EPA-logo.5c7b16b3.svg";